/**
 * Resolves a brand group's client-facing support phone: prefers the published number
 * (with its extension when present), falls back to the support phone, and returns null
 * when neither is set. Formatting is injected so each consumer can keep its own display
 * convention.
 */
export function resolveSupportPhone({ fwdPhonePublished, fwdPhonePublishedExt, fwdPhoneSupport, formatPhoneNumber, }) {
    const rawPhone = fwdPhonePublished || fwdPhoneSupport;
    if (rawPhone === null || rawPhone === undefined || rawPhone === '') {
        return null;
    }
    const formattedPhone = formatPhoneNumber(String(rawPhone)) || null;
    if (!formattedPhone) {
        return null;
    }
    // Ext only applies to the client-facing published number, not the support fallback.
    const publishedExt = fwdPhonePublished ? fwdPhonePublishedExt : null;
    if (publishedExt !== null && publishedExt !== undefined && publishedExt !== '') {
        return `${formattedPhone} Ext. ${publishedExt}`;
    }
    return formattedPhone;
}
